import { render } from "./OrderRejected.vue?vue&type=template&id=5616e9ce&scoped=true"
import script from "./OrderRejected.vue?vue&type=script&lang=js"
export * from "./OrderRejected.vue?vue&type=script&lang=js"

import "./OrderRejected.vue?vue&type=style&index=0&id=5616e9ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5616e9ce"]])

export default __exports__